import angular from 'angular';
import constants from 'app/constants';
import {
  oversightDataService,
  oversightSharedModelService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './agenda-category.controller';
import directive from './agenda-category.directive';
import categoryItem from './agendaItems';


export default angular.module('app.components.advisory.oversight.agendaCategory', [
  alerts,
  oversightDataService,
  oversightSharedModelService,
  constants,
  categoryItem,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('agendaCategory', directive)
  .controller('AgendaCategoryController', controller)
  .name;

console.log('app.components.advisory.oversight.agendaCategory created');
